import React from 'react';
import PropTypes from 'prop-types';

const BRAND_BLUE = '#253746';

// Custom checkbox with branding colors
const Checkbox = ({ checked = false, onChange, label, disabled = false, id, className, style, ...rest }) => {
  const inputId =
    id ||
    `checkbox-${Math.random()
      .toString(36)
      .substr(2, 9)}`;

  const containerStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.6 : 1,
    ...style
  };

  const checkboxContainerStyle = {
    position: 'relative',
    width: '18px',
    height: '18px',
    flexShrink: 0
  };

  const hiddenInputStyle = {
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    margin: 0,
    cursor: disabled ? 'not-allowed' : 'pointer',
    zIndex: 1
  };

  const customCheckboxStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '18px',
    height: '18px',
    backgroundColor: checked ? BRAND_BLUE : '#ffffff',
    border: `2px solid ${BRAND_BLUE}`,
    borderRadius: '3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.15s ease-in-out'
  };

  const checkmarkStyle = {
    display: checked ? 'block' : 'none',
    width: '10px',
    height: '10px'
  };

  const labelStyle = {
    marginLeft: '8px',
    marginBottom: 0,
    cursor: disabled ? 'not-allowed' : 'pointer',
    userSelect: 'none',
    lineHeight: '18px',
    display: 'flex',
    alignItems: 'center'
  };

  return (
    <div style={containerStyle} className={className}>
      <div style={checkboxContainerStyle}>
        <input
          type="checkbox"
          id={inputId}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          style={hiddenInputStyle}
          {...rest}
        />
        <div style={customCheckboxStyle}>
          <svg style={checkmarkStyle} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 6L5 9L10 3" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      </div>
      {label && (
        <label htmlFor={inputId} style={labelStyle}>
          {label}
        </label>
      )}
    </div>
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.node,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};

export default Checkbox;
